module.exports = __webpack_public_path__ + "img/game-bg-icon.22e66a27.svg";